import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { countryGuard } from './country.guard';


export const routes: Routes = [
    { path: "",canActivate: [countryGuard],  loadChildren: () => import('./components/layout/layout.module').then(m => m.LayoutModule) },
    { path: ":country",canActivate: [countryGuard],  loadChildren: () => import('./components/layout/layout.module').then(m => m.LayoutModule) },
    { path: "not-found/:url",  component: NotFoundComponent},
    { path: "**",  component: NotFoundComponent},
    { path: "**/:url",  component: NotFoundComponent},
];
